import { getAttrMarkup, IBuildTaskDef, register } from '@wm/transpiler';
import { IDGenerator } from '@wm/core';

const tagName = 'form';
const idGen = new IDGenerator('form_');

const buildTask = (directiveAttr: string = '', cls: string) => {
  return {
    requires: ['wm-livetable', 'wm-login'],
    pre: (attrs: any, shared: any, parentLiveTable: any, parentLoginWidget: any) => {
      const counter = idGen.nextUid();
      const classProp = attrs.get('formlayout') === 'page' ? 'app-device-liveform panel liveform-inline' : '';
      shared?.set('counter', counter);
      return `<${tagName} wmForm #${counter}="wmForm" role="form" ${directiveAttr} init-widget class="${classProp}" ${getAttrMarkup(attrs)}>`
    },
    post: () => `</${tagName}>`,
    provide: (attrs: any, shared: any) => {
      const provider = new Map();
      provider.set('form_reference', shared?.get('counter'));
      return provider;
    }
  };
}

register('wm-form', () => buildTask('form', 'app-form'));
register('wm-liveform', () => buildTask('wmLiveForm', 'app-liveform liveform-inline'));
register('wm-livefilter', () => buildTask('wmLiveFilter', 'app-livefilter liveform-inline'));


export default () => {};
